import { render } from "./view-layout.modal.vue?vue&type=template&id=72c1297f&scoped=true"
import script from "./view-layout.modal.vue?vue&type=script&lang=js"
export * from "./view-layout.modal.vue?vue&type=script&lang=js"

import "./view-layout.modal.vue?vue&type=style&index=0&id=72c1297f&lang=scss"
import "./view-layout.modal.vue?vue&type=style&index=1&id=72c1297f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c1297f"]])

export default __exports__